(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["box-list"] && !Shopify.designMode) return;
  try {
    
  $('.more-info-click').on('click', function () {
    $(this).siblings('.more-info-content').slideToggle();
    $(this).parent('.more-info').toggleClass('open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-logo-slider"] && !Shopify.designMode) return;
  try {
    
  $('.logo-slides').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 6,
    arrows: false,
    dots: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 1000,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-collection"] && !Shopify.designMode) return;
  try {
    
  $('.category-slides').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 5,
    arrows: true,
    dots: false,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Previous products"></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next products"></button>',
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-content-slider"] && !Shopify.designMode) return;
  try {
    
  $('.single-category-slides').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    arrows: false,
    dots: true,
    slidesToScroll: 1,
    centerPadding: '20px',
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-boxes"] && !Shopify.designMode) return;
  try {
    
    $('.hz-slides').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        arrows:false,
        dots: false,
        slidesToScroll: 1,
        centerPadding: '20px'
    });

    $('.more-info-click').on('click', function () {
        $(this).siblings('.more-info-content').slideToggle();
        $(this).parent('.more-info').toggleClass('open');
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jump-to-section"] && !Shopify.designMode) return;
  try {
    
    const headerHeight = $('.site-header').outerHeight();
    let isAnimating = false;

    // Scroll Event Handler for sidebar menu links
    $(window).on('scroll', function() {
        if (!isAnimating) {
            var scrollPos = $(window).scrollTop();
            var currentSectionId = '';
            $('.faqsGroup').each(function() {
                var sectionTop = $(this).offset().top;
                var sectionHeight = $(this).outerHeight();
                if (scrollPos >= sectionTop - headerHeight && scrollPos < sectionTop + sectionHeight - headerHeight) {
                    currentSectionId = $(this).attr('id');
                }
            });
            $('.all-faqs-main .faqs-Menu li a').removeClass('active');
            if (currentSectionId) {
                $('a[href="#' + currentSectionId + '"]').addClass('active');
            }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  function reviewTextOverflows(desc) {
    return desc.scrollHeight - desc.clientHeight > 1;
  }

  function updateReviewMoreButtons() {
    $('.reviews-slides .reviewCard').each(function () {
      var $card = $(this);
      var $desc = $card.find('.desc');
      var $btn = $card.find('.reviewCard__more');
      if (!$desc.length || !$btn.length) return;

      if ($card.hasClass('is-expanded')) {
        $card.addClass('is-truncated');
        $btn.addClass('is-visible').text('Show less');
        return;
      }

      var overflows = reviewTextOverflows($desc[0]);
      $card.toggleClass('is-truncated', overflows);
      $btn.toggleClass('is-visible', overflows).text('Show more');
    });
  }

  $('.reviews-slides')
    .on('init breakpoint setPosition', function () {
      requestAnimationFrame(updateReviewMoreButtons);
    })
    .slick({
      lazyLoad: 'ondemand',
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      swipe: true,
      touchMove: true,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
          },
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            swipe: true,
            touchMove: true,
            autoplay: true,
            autoplaySpeed: 5000,
          },
        },
      ],
    });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      updateReviewMoreButtons();
    });
  }

  $(document).on('click', '.reviewCard__more', function () {
    var $card = $(this).closest('.reviewCard');
    var expanded = $card.toggleClass('is-expanded').hasClass('is-expanded');
    $(this).text(expanded ? 'Show less' : 'Show more');
    var $slider = $('.reviews-slides');
    $slider.slick('setPosition');
    if (expanded) {
      $slider.slick('slickPause');
    } else if (!$slider.find('.reviewCard.is-expanded').length) {
      $slider.slick('slickPlay');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-animation"] && !Shopify.designMode) return;
  try {
    
  var $marqueeContent = $('.marquee-content').clone();
  $('.marquee-slider').append($marqueeContent);

  // Initialize Slick Slider
  $('.marquee-slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 12000, // Adjust for desired speed, higher is slower
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    variableWidth: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["therapy-bar"] && !Shopify.designMode) return;
  try {
    
  
  // Get the new percentage value from the clicked link
  const newIcePercentage = $('.ice-baths').data('percentage');
  const newSaunaPercentage = 100 - newIcePercentage;
  console.log(newIcePercentage, newSaunaPercentage);

  // Update Ice Bath
  $('.ice-baths')
      .attr('data-percentage', newIcePercentage) // Update data attribute
      .find('.percentage-value').text(`${newIcePercentage}%`); // Update text
  
  // Update Sauna
  $('.saunas')
      .attr('data-percentage', newSaunaPercentage) // Update data attribute
      .find('.percentage-value').text(`${newSaunaPercentage}%`); // Update text

  // Change the inline CSS 'width' property for both elements
  $('.ice-baths').css('width', `${newIcePercentage}%`);
  $('.saunas').css('width', `${newSaunaPercentage}%`);

  } catch(e) { console.error(e); }
})();
})();
